module.exports = __webpack_public_path__ + "img/avalizeinterna.99aa3b9b.png";